/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Success_Whatnext1Inputs */

const he_contact_success_whatnext1 = /** @type {(inputs: Contact_Success_Whatnext1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מה הלאה?`)
};

const en_contact_success_whatnext1 = /** @type {(inputs: Contact_Success_Whatnext1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What's next?`)
};

/**
* | output |
* | --- |
* | "What's next?" |
*
* @param {Contact_Success_Whatnext1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const contact_success_whatnext1 = /** @type {((inputs?: Contact_Success_Whatnext1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Success_Whatnext1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_contact_success_whatnext1(inputs)
	return en_contact_success_whatnext1(inputs)
});
export { contact_success_whatnext1 as "contact_success_whatNext" }